import styled from 'styled-components';
import React from 'react';

export const Separator = () => (
  <SeparatorBase className="d-none d-sm-inline-block m-2" />
);

export const SeparatorBase = styled.span`
  width: 6px;
  height: 6px;

  background: #ccc;
  border-radius: 50%;

  vertical-align: -5px;
`;
